module.exports = __webpack_public_path__ + "img/Indonesia-02.fb25e09f.jpg";